import React, { useMemo } from 'react';
import { getListOfValidTimezones, getTimeZoneLabel } from '../../../utilities/order/getListOfValidTimeZone';
import { SelectOption } from '../../../tailwindComponents/selectTW/interfaces';
import { SelectFieldTW } from '../../../tailwindComponents/selectTW/SelectFieldTW';

export const LocationTimeZoneSelect: React.FC = () => {
  const timeZonesOptions: SelectOption[] = useMemo(
    () =>
      getListOfValidTimezones.map((zone: string) => ({
        label: getTimeZoneLabel(zone),
        value: zone,
      })),
    []
  );
  return <SelectFieldTW name={'timeZone'} options={timeZonesOptions} labelText={'Location/Time Zone'} />;
};
